function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#373A36;}\n\t.st1{fill:#9C4877;}\n\t.st2{fill:#F8F8F7;}\n\t.st3{fill:#E2E2DC;}\n\t.st4{fill:#E64B38;}\n\t.st5{fill:#EFB8A9;}\n\t.st6{fill:none;stroke:#CCCCCC;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st7{fill:#FFC557;}\n\t.st8{fill:none;stroke:#373A36;stroke-width:0.4213;stroke-miterlimit:10;}\n\t.st9{fill:#4A9462;}\n\t.st10{fill:none;stroke:#F8F8F7;stroke-width:0.5;stroke-miterlimit:10;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M35.027,4.049c-0.429-1.596-1.688-2.854-3.283-3.285C28.984,0.009,18.333,0,17.881,0S6.779,0.009,4.018,0.735 C2.449,1.166,1.16,2.466,0.734,4.05C0.009,6.808,0,12.359,0,12.595c0,0.236,0.009,5.815,0.735,8.546 c0.429,1.597,1.688,2.855,3.283,3.285c2.788,0.755,13.411,0.764,13.862,0.764c0.452,0,11.103-0.009,13.861-0.735 c1.597-0.429,2.855-1.688,3.286-3.285c0.726-2.759,0.734-8.31,0.734-8.544C35.764,12.389,35.782,6.809,35.027,4.049z  M35.263,12.624c0,0.057-0.008,5.721-0.718,8.416c-0.384,1.425-1.507,2.548-2.931,2.931c-2.696,0.711-13.623,0.719-13.733,0.719 c-0.109,0-11.007-0.009-13.731-0.746c-1.425-0.384-2.549-1.508-2.932-2.932C0.509,18.345,0.5,12.652,0.5,12.595 c0-0.057,0.008-5.722,0.718-8.417c0.381-1.414,1.531-2.576,2.93-2.959C6.845,0.508,17.771,0.5,17.881,0.5 s11.036,0.009,13.731,0.746c1.426,0.385,2.55,1.508,2.933,2.932V4.18C35.282,6.873,35.263,12.565,35.263,12.624z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M14.116,18.313l9.93-5.719l-9.93-5.719V18.313z M14.616,7.741l8.428,4.854l-8.428,4.854V7.741z"
}));

var SvgYoutube = function SvgYoutube(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35.763 25.189",
    style: {
      enableBackground: "new 0 0 35.763 25.189"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYoutube, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/youtube.c55b43ca.svg";
export { ForwardRef as ReactComponent };